// extracted by mini-css-extract-plugin
export default {"content":"style_content__azq-V","title":"style_title__xv2sg","noAccess":"style_noAccess__T37c9"};